import { useState, useEffect } from "react";
import useFetchProducts from "../../hooks/useFetchProducts.js";
import ProductCard from "../../components/cards/ProductCard.jsx";
import { Skeleton } from "antd";


const Catalog = () => {
    const { products, loading } = useFetchProducts();
    const [randomProducts, setRandomProducts] = useState([]);

    useEffect(() => {
        if (products && products.length > 0) {
            const shuffled = products.sort(() => 0.5 - Math.random());
            setRandomProducts(shuffled.slice(0, 8));
        }
    }, [products]);

    return (
        <div>
            <h2 className="font-bold text-2xl mb-6">Каталог</h2>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
                {loading ? (
                    [...Array(4)].map((_, index) => (
                        <Skeleton.Node
                            key={index}
                            active
                            shape="square"
                            size="large"
                            style={{
                                width: "100%",
                                height: "220px",
                            }}
                            className="w-full sm:w-[200px] md:w-[260px] lg:w-[260px]"
                        />
                    ))
                ) : (
                    randomProducts.map((product) => (
                        <ProductCard key={product.id} product={product} />
                    ))
                )}
            </div>
        </div>
    );
};

export default Catalog;